'use client';

import useBreakpoint from '@/hooks/useBreakpoint';
import HomePaginaMobileFallback from '../Designs/Mobile/fallback';
import HomePaginaDesktopFallback from '../Designs/Desktop/fallback';

export default function HomePaginaFallback() {
  const { breakpoint } = useBreakpoint();

  return breakpoint === 'mobile' ? (
    <HomePaginaMobileFallback />
  ) : (
    <HomePaginaDesktopFallback />
  );
}
